<template>
  <v-text-field
    outlined
    v-model="v"
    :label="title"
    :error-messages="error"
    :disabled="model.disabled || config.disabled || false"
    :hide-details="config.hideDetails || false"
    :dense="config.dense || false"
    :readonly="readonly"
    :prefix="model.prefix"
    v-mask="getMask"
    @keypress="filter($event)"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number],
    model: Object,
    config: { type: Object, default: {} },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    values: Object,
  },
  data() {
    return {
      count: 0,
      useMask: true,
    };
  },
  computed: {
    getMask() {
      if (!this.useMask) return "";
      return "+# (###) ###-##-##";
    },
    title() {
      return this.model?.title + (this.useMask ? "" : "*");
    },
    v: {
      get() {
        // Если первые три символа "996", убираем их
        let result = this.value;
        if (this.model.prepend)
          if ((this.value || "").startsWith(this.model.prepend)) {
            result = this.value.slice(this.model.prepend.length);
          }
        const digits = (this.value || "").replace(/\D/g, "");
        return this.applyMask(digits, this.getMask);
        return result;
      },
      set(v) {
        let result = (this.model.prepend || "") + `${v}`;
        //  if (typeof result === "string" && result) result = parseInt(result);
        if (this.model?.format || this.useMask) {
          result = result.replace(/\D+/g, "");
        }
        if (v === "***") this.useMask = false;
        //console.log("set ", result, this.model?.format, this.useMask);
        this.$emit("input", result);
      },
    },
    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
    isDisable() {
      return this.model?.disabled || this.disabled;
    },
  },
  methods: {
    applyMask(digits, mask) {
      let result = "";
      let d = 0;

      for (let i = 0; i < mask.length; i++) {
        if (mask[i] === "#") {
          if (d < digits.length) {
            result += digits[d];
            d++;
          } else break; // прекращаем как только цифры закончились
        } else {
          // добавляем масочный символ, но только если есть хотя бы 1 цифра вперёд
          if (d < digits.length) {
            result += mask[i];
          } else break;
        }
      }
      return result;
    },
    filter: function (evt) {
      evt = evt ? evt : window.event;
      let key = evt.key.toString();
      const v = evt.target.value.toString();
      let expect = evt.target.value.toString() + evt.key.toString();
      if (this.useMask)
        if (evt.key.toString() == "*") {
          this.count++;
          evt.preventDefault();
          if (this.count == 3) {
            this.useMask = false;
            this.$emit("mutate", "maskDisable");
          }
        } else {
          this.count = 0;
        }
      const r = new RegExp(this.model?.mask || "");
      if (!this.useMask) return true;
      if (r.test(key)) return true;
      if (!r.test(expect)) {
        evt.target.value = v;
        evt.preventDefault();
        return false;
        //evt = "";
        //return true;
      } else {
        return true;
      }
    },
  },
};
</script>
